import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import MyAccountCompanyAutosuggest from 'Component/MyAccountCompanyAutosuggest';
import { VALIDATION_INPUT_TYPE_NUMBER } from 'Util/Validator/Config';

import './MyAccountCompanySearchForm.style';

/** @namespace PeggysagePwa/Component/MyAccountCompanySearchForm/Component */
export class MyAccountCompanySearchFormComponent extends PureComponent {
    static propTypes = {
        onZipcodeChange: PropTypes.func.isRequired,
        validateZipcodeField: PropTypes.func.isRequired,
        onSuggestionSelected: PropTypes.func.isRequired,
        onSkip: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        currentZipcode: PropTypes.string.isRequired,
        isCompanyFieldDisabled: PropTypes.bool.isRequired,
        isSubmitDisabled: PropTypes.bool.isRequired
    };

    renderDescription() {
        return (
            <p>
                { __('Remplissez votre code postal et le nom de votre entreprise '
                    + 'pour pré-remplir vos informations') }
            </p>
        );
    }

    renderZipcodeField() {
        const {
            currentZipcode,
            onZipcodeChange,
            validateZipcodeField
        } = this.props;

        // eslint-disable-next-line
        const fieldLength = 5;

        return (
            <fieldset block="MyAccountOverlay" elem="Legend">
                <Field
                  type={ FIELD_TYPE.text }
                  label={ __('Zip / Postal code') }
                  attr={ {
                      name: 'postcode',
                      defaultValue: currentZipcode,
                      placeholder: __('Zip / Postal code'),
                      maxLength: fieldLength
                  } }
                  events={ {
                      onChange: onZipcodeChange
                  } }
                  addRequiredTag
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      inputType: VALIDATION_INPUT_TYPE_NUMBER.numeric,
                      isRequired: true,
                      match: validateZipcodeField
                  } }
                />
            </fieldset>
        );
    }

    renderAutosuggestField() {
        const {
            currentZipcode,
            isCompanyFieldDisabled,
            onSuggestionSelected
        } = this.props;

        return (
            <MyAccountCompanyAutosuggest
              zipcode={ currentZipcode }
              isDisabled={ isCompanyFieldDisabled }
              onSuggestionSelected={ onSuggestionSelected }
            />
        );
    }

    renderSkipContent() {
        const { onSkip } = this.props;

        return (
            <div block="MyAccountCompanySearchForm" elem="Skip">
                <p>{ __('Je ne trouve pas mon entreprise ?') }</p>
                <button
                  block="Button"
                  type="button"
                  mix={ { block: 'MyAccountCompanySearchForm', elem: 'SkipButton' } }
                  mods={ { likeLink: true } }
                  onClick={ onSkip }
                >
                    { __('Saisir les informations manuellement') }
                </button>
            </div>
        );
    }

    renderSubmitButton() {
        const { onSubmit, isSubmitDisabled } = this.props;

        return (
            <div block="MyAccountCompanySearchForm" elem="Buttons">
                <button
                  block="Button"
                  type="button"
                  mix={ { block: 'MyAccountCompanySearchForm', elem: 'SubmitButton' } }
                  onClick={ onSubmit }
                  disabled={ isSubmitDisabled }
                >
                    { __('Continue') }
                </button>
            </div>
        );
    }

    renderContent() {
        return (
            <>
                { this.renderDescription() }
                { this.renderZipcodeField() }
                { this.renderAutosuggestField() }
                { this.renderSkipContent() }
                { this.renderSubmitButton() }
            </>
        );
    }

    render() {
        return (
            <div block="MyAccountCompanySearchForm">
                { this.renderContent() }
            </div>
        );
    }
}

export default MyAccountCompanySearchFormComponent;
